module.exports = "/_next/static/images/fallback_XL-51f66fda8179533d718435894930e3d1.png";